/* tslint:disable */
/* eslint-disable */
/**
 * Flawtrack Backend
 * Flawtrack ASM
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Finding,
  PaginatedFindingList,
  PatchedFinding,
} from '../models/index';
import {
    FindingFromJSON,
    FindingToJSON,
    PaginatedFindingListFromJSON,
    PaginatedFindingListToJSON,
    PatchedFindingFromJSON,
    PatchedFindingToJSON,
} from '../models/index';

export interface AssetFindingsListRequest {
    assetId: number;
    assetType: string;
    teamSlug: string;
    createdLast?: number;
    limit?: number;
    ordering?: string;
    page?: number;
    search?: string;
    severity?: string;
    status?: string;
}

export interface FindingsCreateRequest {
    teamSlug: string;
    finding: Omit<Finding, 'id'|'asset_type_name'|'asset_name'|'created_at'|'evidences'|'updated_at'|'history'>;
}

export interface FindingsDestroyRequest {
    id: string;
    teamSlug: string;
}

export interface FindingsEvidencesRetrieveRequest {
    id: string;
    teamSlug: string;
}

export interface FindingsListRequest {
    teamSlug: string;
    assetId?: number;
    assetType?: string;
    createdLast?: number;
    limit?: number;
    ordering?: string;
    page?: number;
    search?: string;
    severity?: string;
    status?: string;
}

export interface FindingsPartialUpdateRequest {
    id: string;
    teamSlug: string;
    patchedFinding?: Omit<PatchedFinding, 'id'|'asset_type_name'|'asset_name'|'created_at'|'evidences'|'updated_at'|'history'>;
}

export interface FindingsRetrieveRequest {
    id: string;
    teamSlug: string;
}

export interface FindingsUpdateRequest {
    id: string;
    teamSlug: string;
    finding: Omit<Finding, 'id'|'asset_type_name'|'asset_name'|'created_at'|'evidences'|'updated_at'|'history'>;
}

/**
 * 
 */
export class FindingsApi extends runtime.BaseAPI {

    /**
     */
    async assetFindingsListRaw(requestParameters: AssetFindingsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedFindingList>> {
        if (requestParameters['assetId'] == null) {
            throw new runtime.RequiredError(
                'assetId',
                'Required parameter "assetId" was null or undefined when calling assetFindingsList().'
            );
        }

        if (requestParameters['assetType'] == null) {
            throw new runtime.RequiredError(
                'assetType',
                'Required parameter "assetType" was null or undefined when calling assetFindingsList().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling assetFindingsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['createdLast'] != null) {
            queryParameters['created_last'] = requestParameters['createdLast'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['severity'] != null) {
            queryParameters['severity'] = requestParameters['severity'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/findings/{team_slug}/assets/{asset_type}/{asset_id}/`.replace(`{${"asset_id"}}`, encodeURIComponent(String(requestParameters['assetId']))).replace(`{${"asset_type"}}`, encodeURIComponent(String(requestParameters['assetType']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedFindingListFromJSON(jsonValue));
    }

    /**
     */
    async assetFindingsList(requestParameters: AssetFindingsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedFindingList> {
        const response = await this.assetFindingsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async findingsCreateRaw(requestParameters: FindingsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Finding>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling findingsCreate().'
            );
        }

        if (requestParameters['finding'] == null) {
            throw new runtime.RequiredError(
                'finding',
                'Required parameter "finding" was null or undefined when calling findingsCreate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/findings/{team_slug}/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: FindingToJSON(requestParameters['finding']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindingFromJSON(jsonValue));
    }

    /**
     */
    async findingsCreate(requestParameters: FindingsCreateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Finding> {
        const response = await this.findingsCreateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async findingsDestroyRaw(requestParameters: FindingsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findingsDestroy().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling findingsDestroy().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/findings/{team_slug}/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async findingsDestroy(requestParameters: FindingsDestroyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.findingsDestroyRaw(requestParameters, initOverrides);
    }

    /**
     * Get evidences for a specific finding
     */
    async findingsEvidencesRetrieveRaw(requestParameters: FindingsEvidencesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Finding>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findingsEvidencesRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling findingsEvidencesRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/findings/{team_slug}/{id}/evidences/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindingFromJSON(jsonValue));
    }

    /**
     * Get evidences for a specific finding
     */
    async findingsEvidencesRetrieve(requestParameters: FindingsEvidencesRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Finding> {
        const response = await this.findingsEvidencesRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async findingsListRaw(requestParameters: FindingsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PaginatedFindingList>> {
        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling findingsList().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['assetId'] != null) {
            queryParameters['asset_id'] = requestParameters['assetId'];
        }

        if (requestParameters['assetType'] != null) {
            queryParameters['asset_type'] = requestParameters['assetType'];
        }

        if (requestParameters['createdLast'] != null) {
            queryParameters['created_last'] = requestParameters['createdLast'];
        }

        if (requestParameters['limit'] != null) {
            queryParameters['limit'] = requestParameters['limit'];
        }

        if (requestParameters['ordering'] != null) {
            queryParameters['ordering'] = requestParameters['ordering'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['severity'] != null) {
            queryParameters['severity'] = requestParameters['severity'];
        }

        if (requestParameters['status'] != null) {
            queryParameters['status'] = requestParameters['status'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/findings/{team_slug}/`.replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PaginatedFindingListFromJSON(jsonValue));
    }

    /**
     */
    async findingsList(requestParameters: FindingsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PaginatedFindingList> {
        const response = await this.findingsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async findingsPartialUpdateRaw(requestParameters: FindingsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Finding>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findingsPartialUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling findingsPartialUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/findings/{team_slug}/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: PatchedFindingToJSON(requestParameters['patchedFinding']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindingFromJSON(jsonValue));
    }

    /**
     */
    async findingsPartialUpdate(requestParameters: FindingsPartialUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Finding> {
        const response = await this.findingsPartialUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async findingsRetrieveRaw(requestParameters: FindingsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Finding>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findingsRetrieve().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling findingsRetrieve().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/findings/{team_slug}/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindingFromJSON(jsonValue));
    }

    /**
     */
    async findingsRetrieve(requestParameters: FindingsRetrieveRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Finding> {
        const response = await this.findingsRetrieveRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async findingsUpdateRaw(requestParameters: FindingsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Finding>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling findingsUpdate().'
            );
        }

        if (requestParameters['teamSlug'] == null) {
            throw new runtime.RequiredError(
                'teamSlug',
                'Required parameter "teamSlug" was null or undefined when calling findingsUpdate().'
            );
        }

        if (requestParameters['finding'] == null) {
            throw new runtime.RequiredError(
                'finding',
                'Required parameter "finding" was null or undefined when calling findingsUpdate().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && (this.configuration.username !== undefined || this.configuration.password !== undefined)) {
            headerParameters["Authorization"] = "Basic " + btoa(this.configuration.username + ":" + this.configuration.password);
        }
        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("jwtAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = await this.configuration.apiKey("Authorization"); // ApiKeyAuth authentication
        }

        const response = await this.request({
            path: `/findings/{team_slug}/{id}/`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id']))).replace(`{${"team_slug"}}`, encodeURIComponent(String(requestParameters['teamSlug']))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: FindingToJSON(requestParameters['finding']),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => FindingFromJSON(jsonValue));
    }

    /**
     */
    async findingsUpdate(requestParameters: FindingsUpdateRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Finding> {
        const response = await this.findingsUpdateRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
